import { SearchExpression } from '../../model/search/advanced/SearchExpression';
import { ISearch } from '../../model/search/ISearch';

export abstract class BaseSearchService {
  public abstract Search(project, collection: any, expression: ISearch, columnFilters?: SearchExpression, sortBy?: string, sortDirection?: any, page?: number, limit?: number): Promise<any>;
}
